<template>
  <div>
    <p id="about-title" :style="isRtl ? 'font-size: 36px' : 'font-size: 30px'">
      {{ $t('My achievements') }}
    </p>
    <ul id="about-text">
      <li
        v-for="(x, index) in infos"
        :key="index"
        :style="isRtl ? 'font-size: 18px' : 'font-size: 16px'"
      >
        {{ $t(x) }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      isRtl: 'getRtl'
    })
  },
  data() {
    return {
      infos: [
        'I have a degree in management and accounting at the British Institute of Accounting and Management.',
        'Diploma degree in business management At Sulaymaniyah commercial college preparatory',
        'Member of International association of bookkeepers.',
        'Member of Kurdistan accountants & Auditor syndicate.',
        'Member of travel and tourism association of Kurdistan since 2013.',
        'Platinum member of Kurdistan Union of Chamber of Commerce in Sulaymaniyah.',
        'Member of importer & exporter Union of Kurdistan region of Iraq.'
      ]
    }
  }
}
</script>

<style lang="scss">
$secondaryColor: #e01e37;
$primaryColor: #38285a;
$backgroundColor: #e1e5e8;

#about-me {
  position: relative;
  background-color: $backgroundColor;
  padding: 100px 70px;
}

#about-title {
  text-align: center;
  font-size: 30px;
  padding-bottom: 50px;
  margin-top: 0px;
}
</style>
